<template>
  <div>
    <AppToolbox
      @refresh="onRefresh"
      :search.sync="search"
      :selectedItem="selectedItem"
      :formData="scopedFormData"
      :detailData="scopedDetailData"
      :filterData="scopedFilterData"
      :modeEditForm="modeEditForm"
      :apiUrl="apiUrl"
      :formUpload="formUpload">

      <template #filter="scope">
        <div class="row">
          <div class="col" v-if="isApprover">
            <v-select
              v-model="scope.data.companyId"
              :options="listOptions.companies"
              :reduce="item => item.ID"
              placeholder="Instansi / OPD"
              label="Name"
              @input="loadEmployeeByCompany"/>
          </div>

          <div class="col">
            <v-select
              v-model="scope.data.typeId"
              :options="listOptions.employeeWorkLeaveTypes"
              :reduce="item => item.ID"
              placeholder="Tipe Ijin"
              @input="onRefresh"
              label="Name"/>
          </div>

          <div class="col">
            <v-select
              v-model="scope.data.statusId"
              :options="listOptions.employeeWorkLeaveStatuses"
              :reduce="item => item.ID"
              placeholder="Status Persetujuan"
              @input="onRefresh"
              label="Name"/>
          </div>

          <div class="col">
            <v-select
              v-model="scope.data.employeeTypeId"
              :options="listOptions.employeeTypes"
              :reduce="item => item.ID"
              placeholder="Tipe Pegawai"
              @input="onRefresh"
              label="Name"/>
          </div>
          <!-- 
          <div class="col">
            <v-select
              v-model="scope.data.employeeId"
              :options="listOptions.Employees"
              :reduce="item => item.ID"
              placeholder="Pegawai"
              @input="onRefresh"
              label="Name"/>
          </div>
           -->
        </div>
      </template>

      <template #form="scope">
        <div class="form-group">
          <label>Judul Dokumen</label>
          <input class="form-control d-block w-100" v-model="scope.data.Name" required>
        </div>

        <div class="form-group">
          <label>Keterangan</label>
          <input class="form-control d-block w-100" v-model="scope.data.Description">
        </div>
        
        <div class="form-group" v-if="!isEmployee">
          <label>Pegawai Ybs.</label>
          <v-select
            v-model="scope.data.EmployeeID"
            :options="listOptions.employees"
            :reduce="item => item.ID"
            label="Name">

            <template #option="opt">
              <p class="font-weight-bold m-0">{{ opt.Name }}</p>
              <em>NIP: {{ opt.EmployeeIdNumber }}</em>
            </template>
          </v-select>
        </div>

        <div class="form-group">
          <label>Alasan</label>
          <v-select
            v-model="scope.data.EmployeeWorkLeaveTypeID"
            :options="listOptions.employeeWorkLeaveTypes"
            :reduce="item => item.ID"
            :required="!scope.data.EmployeeWorkLeaveTypeID"
            label="Name"/>
        </div>

        <div class="form-group">
          <label>Tanggal Awal</label>
          <b-form-datepicker v-model="scope.data.StartDate" locale="id" class="mb-2"></b-form-datepicker>
        </div>

        <div class="form-group">
          <label>Tanggal Selesai</label>
          <b-form-datepicker v-model="scope.data.EndDate" locale="id" class="mb-2"></b-form-datepicker>
        </div>

        <button class="btn btn-primary btn-sm btn-block" type="submit">Simpan dan lanjut Upload Dokumen</button>
      </template>

      <template #upload="scope">
        <div class="form-group text-center">
          <p>Harap menggunggah dokumen ijin yang sudah ditanda-tangani oleh pimpinan</p>
          <label class="btn btn-info" style="cursor: pointer;">
            <i class="fas fa-upload"></i>
            Upload File Ijin
            <input type="file" @change="handleFileUpload" style="display: none;">
          </label>
          <p class="help-block" v-if="scope.data.file">
            <!-- File akan diganti dengan -->
            {{ scope.data.file.name }}
          </p>
        </div>

        <button class="btn btn-primary btn-sm btn-block" type="submit">Simpan</button>
      </template>

      <template #detail="scope">
        <b-table-simple small stacked>
          <b-tbody>
            <b-tr>
              <b-td stacked-heading="Judul Dokumen">{{ scope.data.Name }}</b-td>
              <b-td stacked-heading="Keterangan">{{ scope.data.Description }}</b-td>
              <b-td stacked-heading="Instansi / OPD">{{ scope.data.Company.Name }}</b-td>
              <b-td stacked-heading="Pegawai">{{ scope.data.Employee.Name }}</b-td>
              <b-td stacked-heading="Tipe Ijin">{{ scope.data.EmployeeWorkLeaveType.Name }}</b-td>
              <b-td stacked-heading="Status Persetujuan">{{ scope.data.EmployeeWorkLeaveStatus.Name }}</b-td>
              <b-td stacked-heading="Tanggal Mulai">{{ $helper.formatDateWithDay(scope.data.StartDate) }}</b-td>
              <b-td stacked-heading="Tanggal Selesai">{{ $helper.formatDateWithDay(scope.data.EndDate) }}</b-td>
              <b-td stacked-heading="Ditambahkan Oleh">{{ scope.data.CreatedName }}</b-td>
              <b-td stacked-heading="Diperbarui Oleh">{{ scope.data.UpdatedName }}</b-td>
              <b-td stacked-heading="Tanggal Ditambahkan">{{ $helper.formatDateWithDay(scope.data.CreatedAt) }}</b-td>
              <b-td stacked-heading="Tanggal Diperbarui">{{ $helper.formatDateWithDay(scope.data.UpdatedAt) }}</b-td>
              <b-td stacked-heading="Tanggal Upload">{{ $helper.formatDateWithDay(scope.data.UploadedAt) }}</b-td>
              <b-td stacked-heading="File">
                <a :href="$constant.baseURL + scope.data.File" target="_blank" class="btn btn-primary btn-sm">
                  Lihat File
                </a>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </template>

      <template #additionalButton="scope">
        <span v-if="isApprover">
          <button
            class="btn btn-sm btn-success"
            :disabled="!selectedItem"
            v-b-tooltip.hover
            title="Sejutui"
            @click="approve">
            <i class="fas fa-check"></i>
            <span class="d-none d-lg-inline-block ml-1">Sejutui</span>
          </button>

          <button
            class="btn btn-sm btn-warning btn-icon-split"
            :disabled="!selectedItem"
            v-b-tooltip.hover
            title="Ubah"
            @click="editRow">
            <span class="icon">
              <i class="fas fa-edit" />
            </span>
            <span class="text d-none d-lg-inline-block">Ubah</span>
          </button>

          <button
            class="btn btn-sm btn-danger"
            :disabled="!selectedItem"
            v-b-tooltip.hover
            title="Tolak"
            @click="decline">
            <i class="fas fa-times"></i>
            <span class="d-none d-lg-inline-block ml-1">Tolak</span>
          </button>
        </span>
      </template>

    </AppToolbox>

    <AppTable
      :apiUrl="tableDataUrl"
      :fields="tableFields"
      :search="search"
      :filter="scopedFilterData"
      @onSelectItem="selectedItem = $event" />
  </div>
</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.onRefresh()

    this.loadOptionData()

    this.loadEmployeeByCompany()
  },
  data() {
    return {
      apiUrl: '/employee-work-leave',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'Name', label: 'Judul Dokumen' },
        { key: 'EmployeeWorkLeaveType', label: 'Alasan', formatter: value => value.Name },
        { key: 'Employee', label: 'Nama Pegawai', formatter: value => value.Name },
        { key: 'UploadedAt', label: 'Tgl Upload', formatter: value => this.$helper.formatDateWithDay(value) },
        // { key: 'EmployeeWorkLeaveType', label: 'Tipe Ijin', formatter: value => value.Name },
        { key: 'EmployeeWorkLeaveStatus', label: 'Status Persetujuan', formatter: value => {
          if (value.ID === 3) {
            return `<span class="badge badge-danger">${value.Name}</span>`
          } else if (value.ID === 5) {
            return `<span class="badge badge-success">${value.Name}</span>`
          } else {
            return `<span class="badge badge-light">${value ? value.Name : ''}</span>`
          }
        }},
        { key: 'VerifiedAt', label: 'Tgl diverifikasi', formatter: value => this.$helper.formatDateWithDay(value) },
        { key: 'StartDate', label: 'Tgl Mulai', formatter: value => this.$helper.formatDateWithDay(value) },
        { key: 'EndDate', label: 'Tgl Selesai', formatter: value => this.$helper.formatDateWithDay(value) },
        { key: 'File', label: 'Dokumen', formatter: value => {
          if (!value) {
            return `<span class="badge badge-warning">Belum Upload</span>`
          } else {
            return `
              <a href="${this.$constant.baseURL + value}" target="_blank" class="btn btn-primary btn-sm">
                Lihat File
              </a>
            `
          }
        }}
      ],
      selectedItem: null,
      search: '',
      scopedFormData: {
        ID: null,
        Name: '',
        Description: '',
        CompanyID: JSON.parse(localStorage.getItem('userData')).employee.CompanyID,
        EmployeeID: null,
        EmployeeWorkLeaveTypeID: null,
        EmployeeWorkLeaveStatusID: 1,
        StartDate: new Date(),
        EndDate: new Date(),
        File: null
      },
      scopedDetailData: {
        Name: '',
        Description: '',
        Company: { Name: '' },
        Employee: { Name: '' },
        EmployeeWorkLeaveType: { Name: '' },
        EmployeeWorkLeaveStatus: { Name: '' },
        StartDate: '1990-01-01',
        EndDate: '1990-01-01',
        File: null,
        CreatedName: '',
        UpdatedName: '',
        CreatedAt: '1990-01-01',
        UpdatedAt: '1990-01-01',
        UploadedAt: '1990-01-01'
      },
      scopedFilterData: {
        companyId: null,
        typeId: null,
        statusId: 1,
        employeeId: null,
        employeeTypeId: null
      },
      listOptions: {
        companies: [],
        employees: [],
        employeeWorkLeaveTypes: [],
        employeeWorkLeaveStatuses: [],
        employeeTypes: []
      },
      formUpload: {
        file: ''
      },
      modeEditForm: false
    }
  },

  computed: {
    isApprover () {
      return this.$store.state.user.userData.roles.some(item => (item.ID === 5 || item.ID === 9 || item.ID === 11))
    },
    isEmployee () {
      return this.$store.state.user.userData.roles.some(item => (item.ID === 12))
    },
    currentCompanyId () {
      return this.$store.state.user.userData.employee.Company.ID
    },
    tableDataUrl () {
      let url = this.apiUrl + '?companyId=' + this.currentCompanyId

      if (this.isApprover) {
        url = this.apiUrl
      }

      return url
    }
  },

  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },

    handleFileUpload(event) {
      this.formUpload.file = event.target.files[0]
    },

    loadOptionData () {
      this.$axios.get('/company').then((res) => {
        this.listOptions.companies = res.data
      })

      this.$axios.get('/employee-work-leave-type').then((res) => {
        this.listOptions.employeeWorkLeaveTypes = res.data
      })

      this.$axios.get('/employee-work-leave-status').then((res) => {
        this.listOptions.employeeWorkLeaveStatuses = res.data
      })

      this.$axios.get('/employee-type').then((res) => {
        this.listOptions.employeeTypes = res.data
      })
    },

    loadEmployeeByCompany () {
      this.$axios.get(`/employee/get-by-company/${this.currentCompanyId}`).then((res) => {
        this.listOptions.employees = res.data

        this.onRefresh()
      })
    },

    approve () {
      const url = `/employee-work-leave-status-change/${this.selectedItem.ID}`

      this.$axios.post(url, { EmployeeWorkLeaveStatusID: 5 }).then(res => {
        this.$emit('refreshTable')

        this.$bvToast.toast('Berhasil disimpan', {
          title: 'Sukses!!',
          variant: 'success',
          solid: true
        })
      })
    },

    editRow () {
      this.modeEditForm = true
      this.$emit('edit')

      this.formData = this.scopedFormData

      console.log(this.formData)

      for (const key of Object.keys(this.formData)) {
        if ((typeof this.selectedItem[key] === 'string') && this.selectedItem[key].includes('-') && Date.parse(this.selectedItem[key])) {
         this.formData[key] = new Date(this.selectedItem[key])
        } else 
        if (key === 'Password') {
          this.formData[key] = null
        // } else if (Array.isArray(this.selectedItem[key])) {
        //   this.formData[key] = this.selectedItem[key].map(item => item.ID)
        } else {
          this.formData[key] = this.selectedItem[key]
        }

      }

      this.$bvModal.show('modalForm')
    },

    decline () {
      const url = `/employee-work-leave-status-change/${this.selectedItem.ID}`

      this.$axios.post(url, { EmployeeWorkLeaveStatusID: 3 }).then(res => {
        this.$emit('refreshTable')

        this.$bvToast.toast('Berhasil disimpan', {
          title: 'Sukses!!',
          variant: 'success',
          solid: true
        })
      })
    },
  }
}
</script>
